var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.func.isRequired,
  defaultValue: PropTypes.bool,
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onToggle: PropTypes.func
};

var defaultProps = {
  defaultValue: true,
  groupId: 0,
  onToggle: function onToggle() {
    return undefined;
  }
};

var NavToggle = function (_React$Component) {
  _inherits(NavToggle, _React$Component);

  function NavToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavToggle.__proto__ || Object.getPrototypeOf(NavToggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: _this.props.defaultValue
    }, _this.handleToggle = function (e) {
      // Item events can bubble up, ignore those
      if (e.target.getAttribute('data-component') !== 'pf-nav-expandable') {
        return;
      }
      var value = _this.state.value;
      var _this$props = _this.props,
          groupId = _this$props.groupId,
          onToggle = _this$props.onToggle;

      _this.setState({
        value: !value
      });
      onToggle(e, groupId, !value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavToggle, [{
    key: 'render',
    value: function render() {
      return this.props.children({
        value: this.state.value,
        toggle: this.handleToggle
      });
    }
  }]);

  return NavToggle;
}(React.Component);

NavToggle.propTypes = propTypes;
NavToggle.defaultProps = defaultProps;


export default NavToggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Nav/NavToggle.js
// module id = 272
// module chunks = 0